// extracted by mini-css-extract-plugin
module.exports = {"productVideo":"ProductVideo_productVideo__P_0il"};